
import { Component, Vue } from "vue-property-decorator";
import ConfirmDialog from "@/components/UI/ConfirmDialog.vue";
import { uiStore } from "@/store/store-accessor";
import {
  ClosingConfirmationChosenOption,
  ClosingConfirmationSubject
} from "@/types/ui";

@Component({
  components: {
    ConfirmDialog
  }
})
export default class ClosingConfirmations extends Vue {
  get closingConfirmations() {
    return Object.fromEntries(
      Object.entries(uiStore.closingConfirmations).filter(
        ([, confirmation]) => {
          return confirmation && confirmation.show;
        }
      )
    );
  }

  markClosingConfirmationAs(
    subject: ClosingConfirmationSubject,
    chosenOption: ClosingConfirmationChosenOption
  ) {
    uiStore.chooseOptionForClosingConfirmation({ subject, chosenOption });
  }

  hideClosingConfirmation(subject: ClosingConfirmationSubject) {
    uiStore.hideClosingConfirmation(subject);
  }
}
